import axios from "@/api/axiosInstance";
import { GetBillingMetadataResponse } from "./types";

export const getBillingMetadata = async (
  signal?: AbortSignal,
): Promise<GetBillingMetadataResponse> => {
  const response = await axios.get<GetBillingMetadataResponse>(
    "/api/private/billing/metadata",
    { signal },
  );
  return response.data;
};
